import styled from '@emotion/styled';
import React, { ReactNode } from 'react';
import { switchProp } from 'styled-tools';
import { Link } from '~/lib/data-contract/auto-generated/api-model';
import { StyledAccordionItem } from '~/shared/components';
import { StyledRichText } from '~/shared/components/RawHtml/styled';
import { SectionTitle } from '~/shared/components/Summary/components/SectionTitle';
import { StyledText } from '~/shared/components/Text/styled';
import { SFProduct } from '../pdp.definitions';

type Props = {
    product?: SFProduct | null;
    variants?: SFProduct[] | null;
    categories?: Link[] | null;
    children?: ReactNode;
    className?: string;
    hasData?: boolean;
};

export const PDPSummary = styled(({ className, children }: Props) => {
    return <div className={className}>{children}</div>;
})(
    ({ theme }) => ({
        border: `1px solid ${theme.colors.brownLight}`,
        transition: 'opacity 0.3s ease-in-out',
        [`${StyledRichText}`]: {
            textAlign: 'left',
            ...theme.mixins.useTextStyle('bodySmall'),
            '& li,ul,p': {
                marginBottom: 0,
            },

            'p,ul': {
                marginBottom: theme.space[1],
            },
            strong: {
                fontWeight: theme.mixins.useFontWeight('Bold'),
            },
            'p:not(:first-of-type) > strong': {
                display: 'inline-block',
                marginTop: theme.space[3],
            },
        },
        [`${StyledText}`]: {
            ...theme.mixins.useTextStyle('bodySmall'),
            textAlign: 'left',
            '& > *': {
                textAlign: 'left',
            },
        },
        [`${StyledAccordionItem}`]: {
            [`${SectionTitle}`]: {
                textAlign: 'left',
                borderBottom: 'none',
            },
        },
    }),
    switchProp('hasData', {
        true: {
            opacity: 1,
        },
        false: {
            opacity: 0,
        },
    })
);
